// extracted by mini-css-extract-plugin
export default {"leave":"leave-URvse","leaveActive":"leaveActive-1yQR8"};